import { clearCookie } from '@tencent/vft-common/login/lib.js';

export default response => new Promise((resolve) => {
  if (response.ret === -11) {
    clearCookie(() => {
      const { magicApp } = window;
      if (magicApp) {
        magicApp.$store.commit('saveIsLogin', false);
        magicApp.$store.commit('saveUserInfo', null);
        magicApp.$store.commit('savePayVip', null);
        setTimeout(() => {
          magicApp.openLogin({}, true);
        }, 1000);
      }
    });
    console.error('登录态失效，请重新登录');
  } else {
    resolve(response);
  }
});
